import { AppRootState } from 'app/store'
import { dashboardReducer } from 'features/dashboard'

export const loadState: Function = (name: string): unknown | undefined => {
  try {
    const savedState = localStorage.getItem(name)

    if (savedState === null) {
      return undefined
    }

    return JSON.parse(savedState)
  } catch (e) {
    return undefined
  }
}

export const saveState = (name: string, data: unknown) => {
  try {
    const serializedState = JSON.stringify(data)

    localStorage.setItem(name, serializedState)
  } catch (e) {
    console.error(e)
  }
}
